import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function HoumaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Houma"
      headingExtra="LA"
      introText="Houma travelers — offshore oil rig workers rotating internationally, Nicholls State students studying abroad, and Terrebonne Parish families with relatives overseas — have several passport options. Here's how they compare, and why most Houma residents choose a registered State Department courier."
      options={options}
      emergencyDescription="New Orleans ~60 mi via LA-1/US-90/I-310 — but the distance is deceptive. Louisiana has only ONE passport agency serving 4.6M+ residents statewide. LA-1 runs through marshland and bayou country — heavy rain floods the highway between Houma and the I-310 interchange, and there is no viable alternate route. During hurricane season (June–November), a Category 3+ storm approaching the Gulf triggers mandatory evacuations that turn US-90 into gridlock. The New Orleans agency itself closed for weeks after Katrina — when the next major hurricane hits, Houma's sole connection to Louisiana's single passport agency becomes a flooded highway through evacuated marshland. Offshore workers on short-notice international rotation cannot wait for the water to recede."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}